import { render, staticRenderFns } from "./BuildYourJewelSelectedStones.vue?vue&type=template&id=2fbafb82&scoped=true&"
import script from "./BuildYourJewelSelectedStones.vue?vue&type=script&lang=js&"
export * from "./BuildYourJewelSelectedStones.vue?vue&type=script&lang=js&"
import style0 from "./BuildYourJewelSelectedStones.vue?vue&type=style&index=0&id=2fbafb82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbafb82",
  null
  
)

export default component.exports